/**
 * WebView Stripe utilities for handling ACH OAuth redirects
 */

export const WEBVIEW_OAUTH_REDIRECT_URL =
  "church-center://payments/oauth-noredirect"

/**
 * Gets WebView-specific Stripe options for payment elements
 * Adds the OAuth redirect URL for US bank account ACH flows
 *
 * @returns {Object} - Additional options to merge with Stripe Elements options
 */
export const getWebViewStripeOptions = () => {
  if (!window.ReactNativeWebView) {
    return {}
  }

  return {
    paymentMethodOptions: {
      us_bank_account: {
        financial_connections: {
          return_url: WEBVIEW_OAUTH_REDIRECT_URL,
        },
      },
    },
  }
}
